<template lang="pug">
  .user-avatar(v-if="user", :class="size", :data-initial="initial", :style="{ backgroundColor: user.color }")
    img(v-if="user.avatarUrl", :src="user.avatarUrl")
    span.icon-wrapper(v-if="icon")
      .icon-center
        font-awesome-icon.icon(:icon="icon")
</template>

<script>


export default {
  name: 'UserAvatar',
  components: {
  },
  props: {
    user: Object,
    icon: {
      type: Array,
      default: null
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    //console.log('user', this.user.avatarUrl)
  },
  computed: {
    initial () {
      let initial = ''
      if (this.user.firstName && this.user.firstName.length > 0) {
        initial += this.user.firstName.charAt(0)
      }
      if (this.user.lastName && this.user.lastName.length > 0) {
        initial += this.user.lastName.charAt(0)
      }
      return initial
    }
  }
}
</script>

<style lang="stylus" scoped>
.user-avatar
  border-radius 100%
  color #fff
  display inline-block
  overflow hidden
  position relative
  &[data-initial]:before
    align-items center
    content attr(data-initial)
    display flex
    height 100%
    font-weight 500
    justify-content center
    line-height 100%
    left 0
    position absolute
    text-align center
    width 100%
    z-index 0
  &.default
    height 30px
    width 30px
  &.header
    height 36px
    width 36px
    font-size 18px
  &.small
    height 20px
    width 20px
    font-size 12px
  img
    border-radius 100%
    max-width 100%
    position relative
    z-index 1
    min-height 100%
    min-width 100%
    
  .icon-wrapper
    align-items center
    background-color $color-primary
    border-radius 100%
    bottom 0
    display flex
    height 50%
    position absolute
    right 0
    width 50%
    transform translate(25%, 25%)
    .icon-center
      text-align center
      margin-top -2px
      width 100%
    .icon
      color #fff
      font-size 60%
</style>